// pages/CourseResume.jsx
// /course/:courseSlug has no page of its own — it resumes the course by
// redirecting into the player at the last-watched lesson (or the first lesson
// for a fresh start). Replaces the old CourseOverview landing page, whose job
// is now split between the enrollment page (/courses/:slug) and the player
// sidebar. Keeps old links and the post-purchase redirect working.

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { coursesApi } from "../api/courses";

function CourseResume() {
  const { courseSlug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    Promise.all([
      coursesApi.getCourse(courseSlug),
      coursesApi.getProgress(courseSlug).catch(() => null),
    ])
      .then(([course, progress]) => {
        if (!active) return;
        const episodes = (course?.modules || []).flatMap((m) => m.episodes || []);
        if (episodes.length === 0) {
          navigate(`/courses/${courseSlug}`, { replace: true });
          return;
        }
        const last = progress?.lastWatchedEpisodeSlug;
        const target =
          last && episodes.some((e) => e.slug === last) ? last : episodes[0].slug;
        navigate(`/courses/${courseSlug}/${target}`, { replace: true });
      })
      .catch(() => active && navigate("/courses", { replace: true }));
    return () => {
      active = false;
    };
  }, [courseSlug, navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafaf9", fontFamily: "'DM Sans', system-ui, sans-serif", color: "#71717a", fontSize: 15 }}>
      Opening course...
    </div>
  );
}

export default CourseResume;
